export default "__VITE_ASSET__Cas_s4zZ__"